// Accounting Main Cashier Vuex

import state from './mainCashierStates.js'
import * as getters from './mainCashierGetters.js'
import * as mutations from './mainCashierMutations.js'
import * as actions from './mainCashierActions.js'

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
